import type { ReactNode } from 'react';

import BpkLabel from '@skyscanner/backpack-web/bpk-component-label';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { Maybe } from '@shared/types/utils';

import STYLES from './FormField.module.scss';

type Props = {
  fieldId: string;
  label?: string;
  children: ReactNode;
  className?: Maybe<string>;
  lightLabel?: boolean;
  hideLabel?: boolean;
};

const cls = cssModules(STYLES);

const FormField = ({
  children,
  className,
  fieldId,
  hideLabel,
  label,
  lightLabel,
}: Props) => {
  const classNames = [STYLES.FormField];
  if (className) {
    classNames.push(className);
  }

  if (!label) {
    classNames.push(STYLES.FormField__withoutLabel);
  }

  return (
    <div className={classNames.join(' ')}>
      {!hideLabel && (
        <BpkLabel
          htmlFor={fieldId}
          className={cls(lightLabel ? 'FormField__label--light' : null)}
          title={label}
        >
          {label}
        </BpkLabel>
      )}
      {children}
    </div>
  );
};

export default FormField;
